import { alpha } from "@mui/material"

// Minimal subset of dataseekers-retailer-front's @utils — only the helpers the
// vendored @app shell imports (mergeDicts, isEmpty, bgBlur, getYear).

const _isPlainObject = (val) =>
    val !== null && typeof val === "object" && !Array.isArray(val) &&
    Object.getPrototypeOf(val) === Object.prototype

/**
 * Deep merge two objects. Arrays are replaced, not merged.
 * Only plain objects ({}) are deep-merged; class instances, signals,
 * functions, etc. are copied by reference.
 */
export function mergeDicts(target, source) {
    if (!source) return target ? { ...target } : {}
    if (!target) return { ...source }
    const result = { ...target }
    for (const key in source) {
        const srcVal = source[key]
        if (_isPlainObject(srcVal)) {
            result[key] = mergeDicts(_isPlainObject(result[key]) ? result[key] : {}, srcVal)
        } else {
            result[key] = srcVal
        }
    }
    return result
}

/**
 * Returns true if value is an empty object {}.
 * Returns null for non-dict values (matches @ui-seeker/utils behavior).
 */
export function isEmpty(obj) {
    if (obj === null || obj === undefined || typeof obj !== "object" || Array.isArray(obj)) return null
    return Object.keys(obj).length === 0
}

/** Returns CSS backdrop-blur styles. */
export function bgBlur({ color = "#000000", blur = 6, opacity = 0.8, imgUrl } = {}) {
    if (imgUrl) {
        return {
            position: "relative",
            backgroundImage: `url(${imgUrl})`,
            "&:before": {
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 9,
                content: '""',
                width: "100%",
                height: "100%",
                backdropFilter: `blur(${blur}px)`,
                WebkitBackdropFilter: `blur(${blur}px)`,
                backgroundColor: alpha(color, opacity),
            },
        }
    }
    return {
        backdropFilter: `blur(${blur}px)`,
        WebkitBackdropFilter: `blur(${blur}px)`,
        backgroundColor: alpha(color, opacity),
    }
}

/** Returns the full year of the given date (defaults to now). */
export const getYear = (date = new Date()) => date.getFullYear()
